function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("path", {
  d: "M18.364 14.418a.91.91 0 111.818 0v4.855A2.727 2.727 0 0117.455 22H4.727A2.727 2.727 0 012 19.273V6.545a2.727 2.727 0 012.727-2.727h4.855a.91.91 0 110 1.818H4.727a.91.91 0 00-.909.91v12.727a.91.91 0 00.91.909h12.727a.91.91 0 00.909-.91v-4.854zm-.267-12.152l3.637 3.637a.91.91 0 010 1.285l-9.091 9.091a.91.91 0 01-.643.266H8.364a.91.91 0 01-.91-.909V12a.91.91 0 01.267-.643l9.09-9.09a.91.91 0 011.286 0zm-8.824 10.11v2.351h2.35l8.182-8.182-2.35-2.35-8.182 8.182z"
});

var SvgEdit = function SvgEdit(props) {
  return React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24"
  }, props), _ref);
};

export default __webpack_public_path__ + "static/media/edit.b5577673.svg";
export { SvgEdit as ReactComponent };